import { routesNames } from '@/core/constants'
import TermoDesentranhamentoRedigirGenerico from '@/views/components/documentos/desentranhar/redigir/TermoDesentranhamentoRedigirGenerico.vue'
import TermoDesentranhamentoAssinarGenerico from '@/views/components/documentos/desentranhar/assinar/TermoDesentranhamentoAssinarGenerico.vue'
import TermoDesentranhamentoJuntarGenerico from '@/views/components/documentos/desentranhar/juntar/TermoDesentranhamentoJuntarGenerico.vue'

export default [
	{
		name: routesNames.ADESAO.PROCESSO_DIGITAL.DESENTRANHAMENTO.PROCESSO_REDIGIR_TERMO_DESENTRANHAMENTO,
		path: 'redigir',
		component: TermoDesentranhamentoRedigirGenerico,
	},
	{
		name: routesNames.ADESAO.PROCESSO_DIGITAL.DESENTRANHAMENTO.PROCESSO_ASSINAR_TERMO_DESENTRANHAMENTO,
		path: 'assinar',
		component: TermoDesentranhamentoAssinarGenerico,
	},
	{
		name: routesNames.ADESAO.PROCESSO_DIGITAL.DESENTRANHAMENTO.PROCESSO_JUNTAR_TERMO_DESENTRANHAMENTO,
		path: 'juntar',
		component: TermoDesentranhamentoJuntarGenerico,
	},
]
